export const ListQueryKey = 'coins';
export const DetailQueryKey = 'coin';

export const Urls = {
  selectUrl: '/coin/list',
  updateUrl: '/coin/update',
  deleteUrl: '/coin/delete',
  createUrl: '/coin/create',
  detailUrl: '/coin/info',
};
